import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter, BrowserRouter } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { ErrorBoundary } from './components/shared/ErrorBoundary'
import { isElectron } from '../common/utils/platform'
import App from './App.tsx'
import './assets/styles/variables.css'
import './index.css'

const Router = isElectron() ? HashRouter : BrowserRouter

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ConfigProvider locale={zhCN}>
        <Router basename={isElectron() ? undefined : '/'}>
          <App />
        </Router>
      </ConfigProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)

// Use contextBridge (electronAPI) — 仅在 Electron 环境中可用
if (window.electronAPI) {
  const cleanup = window.electronAPI.on('main-process-message', (message) => {
    console.log(message)
  })
  window.addEventListener('unload', cleanup)
}
